<template>
  <component :is="`h${level}`" component class="heading">
    <span
      v-if="content"
      class="heading-wrap"
      :class="{ 'is--clamped': maxLines }"
      :style="{
        '-webkit-line-clamp': maxLines || undefined,
        'line-clamp': maxLines || undefined,
      }"
      v-html="sanitizeHTML(content)"
    />
    <slot />
  </component>
</template>

<script setup lang="ts">

interface IProps {
  level?: number;
  content?: string;
  maxLines?: number;
}

withDefaults(defineProps<IProps>(), {
  level: 1,
  content: undefined,
  maxLines: undefined,
});
</script>

<style lang="postcss" scoped>
.heading-wrap {
  &.is--clamped {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
